/* eslint-disable no-underscore-dangle */
/* @link http://stackoverflow.com/questions/46155/validate-email-address-in-javascript */
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const isEmpty = value => (typeof value === 'undefined' || value === null || value === '');

export const required = (value, _, props) => isEmpty(value) ? 'Required' : undefined;

export const minLength = min => (value, _, props) =>
    value && value.length < min ? `Minimal length: ${min}` : undefined;

export const maxLength = max => (value, _, props) =>
    value && value.length > max ? `Maximal length: ${max}` : undefined;

export const minValue = min => (value, _, props) =>
    !isEmpty(value) && value < min ? `Minimum value: ${min}` : undefined;

export const maxValue = max => (value, _, props) =>
    !isEmpty(value) && value > max ? `Maximum value: ${max}` : undefined;

export const number = (value, _, props) => value && isNaN(Number(value)) ? "Must be a number" : undefined;

export const regex = (pattern, message) => (value, _, props) =>
    value && typeof value === 'string' && !pattern.test(value) ? props.translate(message) : undefined;

export const email = regex(EMAIL_REGEX, 'aor.validation.email');

export const choices = (list, message) => (value, _, props) =>
    value && list.indexOf(value) === -1 ? props.translate(message) : undefined;

export const validCustomURL = (value, _, props) => /[^\w\s-]/.test(value) ? 'Custom URL may only contain numbers (0-9), alphabets (a-z, A-Z) and dash (-)' : undefined;

export const validUrl = (value, _, props) => {
    let pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
        '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    if (value.includes('www.')) {
        pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            'www.((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    }
    return !pattern.test(value) ? 'Please input a valid URL' : undefined;
}



// WEBPACK FOOTER //
// ./src/components/form/validate.js